import map from './map'

export default function insert(indexedNodes, nodes, parent, indexLocal) {
  return map(indexedNodes, (n) => {
    if (n === parent) {
      const newChildren = n
        .get('children')
        .slice(0, indexLocal)
        .concat(nodes)
        .concat(n.get('children').slice(indexLocal))
      return n.set('children', newChildren)
    }

    return n
  })
}
